import classNames from "classnames";
import React, { useEffect, useState } from "react";
import Loader from "shared/Loader";
import LoadingContainer from "shared/LoadingContainer";
import PagingControls from "shared/PagingControls";
import Table from "shared/Table";
import formatDate from "shared/@utils/formatDate";
import styles from "./index.module.css";
import { useLocalFunctions } from "./useLocalFunctions";

export default function LocalFunctions({ iboNumber, events }) {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);

  const { records, paging, loading, refresh } = useLocalFunctions({
    iboNumber,
    limit,
    page,
  });

  useEffect(() => {
    if (loading) {
      events.emit("refresh:start");
    } else {
      events.emit("refresh:end");
    }
  }, [loading]);

  // Listen for refresh events on mount and stop listening when unmounted.
  useEffect(() => {
    const listener = () => {
      refresh();
    };

    events.on("refresh", listener);

    return () => {
      events.removeListener("refresh", listener);
    };
  }, [refresh]);

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={styles.container}>
      {records == null ? (
        <Loader />
      ) : (
        <LoadingContainer isLoading={loading}>
          <div className={styles.pagingControls}>
            <PagingControls
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={setLimit}
              disableNext={records.length === 0 || paging.lastPage === page}
              disabled={loading}
            />
          </div>
          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Order ID</th>
                <th>Event Name</th>
                <th>Event Year</th>
                <th>Cost</th>
                <th>Tickets #</th>
              </tr>
            </thead>
            <tbody>
              {records.map((m, i) => {
                return (
                  <tr
                    title={JSON.stringify(m, null, 2)}
                    key={i}
                    onMouseDown={() => {
                      setSelectedIndex(i);
                    }}
                    className={classNames(styles.resultRow, {
                      [styles.selected]: selectedIndex === i,
                    })}
                  >
                    <td>{formatDate(m.createdOn)}</td>
                    <td>{m.orderId}</td>
                    <td>{m.eventName}</td>
                    <td>{m.eventYear}</td>
                    <td className={styles.nowrap}>{m.cost.toFixed(2)}</td>
                    <td>{m.ticketCount}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className={styles.pagingControls}>
            <PagingControls
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={setLimit}
              disableNext={records.length === 0 || paging.lastPage === page}
              disabled={loading}
            />
          </div>
        </LoadingContainer>
      )}
    </div>
  );
}

export function Empty() {
  return <span className={styles.emptyPlaceholder}>---</span>;
}
